var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 129,
    viewBox: "0 0 130 129",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.571 34.2936H1.85547V92.8018H128.571V34.2936Z",
    fill: "url(#paint0_linear_6619_1732)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.459 119.684H40.6494C39.4898 119.684 38.541 120.633 38.541 121.792V125.376C38.541 126.536 39.4898 127.485 40.6494 127.485H89.459C90.6186 127.485 91.5674 126.536 91.5674 125.376V121.792C91.462 120.633 90.6186 119.684 89.459 119.684Z",
    fill: "#4796FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.021 0.980713H17.9863V77.5158H112.021V0.980713Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.032 19.0077H124.881C126.778 19.0077 128.254 20.4836 128.254 22.3811V104.609C128.254 106.507 126.778 107.982 124.881 107.982H5.22893C3.33137 107.982 1.85547 106.507 1.85547 104.609V22.3811C1.85547 20.4836 3.33137 19.0077 5.22893 19.0077H10.3945",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.914 92.6963H128.254",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85547 92.6962H103.059",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4624 119.684H43.074C40.4385 119.684 38.3301 121.792 38.3301 124.428C38.3301 126.009 39.5951 127.38 41.2818 127.38H88.8263C90.4076 127.38 91.7782 126.114 91.7782 124.428C91.7782 121.792 89.6697 119.684 87.0342 119.684H65.3176",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2887 119.684L76.4936 107.982H53.6174L49.8223 119.684",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.607 34.2937H128.147",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85547 34.2936H10.3945",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3777 77.5158H18.0918V0.980713H112.127V77.5158H42.3385",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8148 13.7366L35.8028 21.7485L31.7969 17.7425",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5703 13.8418H98.2113",
    stroke: "#8DBEFF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5703 21.5374H91.7807",
    stroke: "#8DBEFF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8148 35.2419L35.8028 43.2539L31.7969 39.248",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5703 35.4529H98.2113",
    stroke: "#8DBEFF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5703 43.0432H91.7807",
    stroke: "#8DBEFF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8148 56.853L35.8028 64.865L31.7969 60.859",
    stroke: "#0069FF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5703 56.9587H98.2113",
    stroke: "#8DBEFF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5703 64.6543H91.7807",
    stroke: "#8DBEFF",
    strokeWidth: 1.8049,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6619_1732",
    x1: 2.5466,
    y1: 34.7767,
    x2: 126.444,
    y2: 91.6019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DBEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.77fda9a4f16cc0f6936f0ac18a0aa757.svg";
export { ForwardRef as ReactComponent };